/* iPhumat — effets premium (progressive enhancement, accessibles).
 * - Smooth scroll via Lenis (si chargé), sinon scroll natif.
 * - Parallax léger sur [data-parallax].
 * - Boutons magnétiques (.btn--accent / [data-magnetic]) — pointeur fin only.
 * - Compteurs animés (.standard__metric b / [data-count]).
 * Tout est désactivé si prefers-reduced-motion.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initLenis() {
    if (reduce || typeof window.Lenis === 'undefined') return null;
    try {
      var lenis = new window.Lenis({ duration: 1.1, smoothWheel: true, wheelMultiplier: 0.9 });
      function raf(t) { lenis.raf(t); requestAnimationFrame(raf); }
      requestAnimationFrame(raf);
      return lenis;
    } catch (e) { return null; }
  }

  function initMagnetic() {
    if (reduce) return;
    if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
    var els = document.querySelectorAll('.btn--accent, [data-magnetic]');
    els.forEach(function (el) {
      var strength = parseFloat(el.getAttribute('data-magnetic')) || 0.28;
      el.style.willChange = 'transform';
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        el.style.transform = 'translate(' + (x * strength).toFixed(1) + 'px,' + (y * strength).toFixed(1) + 'px)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  function animateCount(el) {
    var text = el.textContent;
    var nums = text.match(/\d+/g);
    if (!nums || nums.length !== 1) return; // n'anime que les valeurs à un seul nombre
    var target = parseInt(nums[0], 10);
    var tpl = text.replace(/\d+/, ' ');
    var dur = 1200, start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = tpl.replace(' ', Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initCounters() {
    if (reduce || !('IntersectionObserver' in window)) return;
    var els = document.querySelectorAll('.standard__metric b, [data-count], [data-counter]');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animateCount(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.6 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    if (reduce) return;
    var items = document.querySelectorAll('[data-parallax]');
    if (!items.length) return;
    var vh = window.innerHeight;
    window.addEventListener('resize', function () { vh = window.innerHeight; });
    function update() {
      for (var i = 0; i < items.length; i++) {
        var el = items[i];
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) continue; // hors écran : on saute
        var speed = parseFloat(el.getAttribute('data-parallax')) || 0.08;
        var offset = (r.top + r.height / 2 - vh / 2) * -speed;
        el.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
      }
      requestAnimationFrame(update);
    }
    requestAnimationFrame(update);
  }

  function run() {
    initLenis();
    initMagnetic();
    initCounters();
    initParallax();
  }
  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
})();
